import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BRAND = "Mindful Minerals";
const SUPPORT_EMAIL = "info@orevital.com";

const TERMS = [
  {
    h: "SMS Terms of Service",
    p: [
      `By opting in to the ${BRAND} / OreVital text messaging program, you agree to these SMS Terms of Service.`,
    ],
  },
  {
    h: "Program description",
    p: [
      "When you opt in, you will receive recurring automated marketing and account text messages, including promotions, new product announcements, and order/account updates.",
    ],
  },
  {
    h: "Message frequency",
    p: ["You will receive up to 4 messages per month. Message frequency may vary."],
  },
  {
    h: "Cost",
    p: [
      "Message and data rates may apply. These are charged by, and payable to, your mobile service provider. Please contact your carrier for details on your plan.",
    ],
  },
  {
    h: "Opt out",
    p: [
      'You can cancel the SMS service at any time by texting "STOP" to the number you receive messages from. After you send "STOP", we will send a confirmation message and then stop sending you SMS messages. To rejoin, sign up again as you did the first time.',
    ],
  },
  {
    h: "Help",
    p: [
      `For help, text "HELP" to the number you receive messages from, or email us at ${SUPPORT_EMAIL}.`,
    ],
  },
  {
    h: "Carriers",
    p: [
      "Carriers are not liable for delayed or undelivered messages. Consent to receive text messages is not a condition of any purchase.",
    ],
  },
];

const PRIVACY = [
  {
    h: "SMS Privacy Policy",
    p: [
      `${BRAND} / OreVital respects your privacy. This policy explains how we handle information collected through our text messaging program.`,
    ],
  },
  {
    h: "Information we collect",
    p: [
      "When you opt in to text alerts we collect your mobile phone number, your consent record, and the date, time, and source of your opt-in.",
    ],
  },
  {
    h: "How we use it",
    p: [
      "We use your phone number solely to send you the text messages you signed up for and to maintain records of your consent as required by law.",
    ],
  },
  {
    h: "No sharing or selling",
    p: [
      "We do not sell, rent, or share your mobile phone number or SMS consent with third parties or affiliates for their marketing purposes. Phone numbers collected for SMS are used only to deliver our own messages, sent through our messaging provider.",
    ],
  },
  {
    h: "Your choices",
    p: [
      'You can unsubscribe at any time by replying "STOP". You may request deletion of your number from our records by emailing ' + SUPPORT_EMAIL + ".",
    ],
  },
  {
    h: "Contact us",
    p: [`Questions about this policy? Email us at ${SUPPORT_EMAIL}.`],
  },
];

export default function SmsLegal({ type = "terms" }) {
  const sections = type === "privacy" ? PRIVACY : TERMS;
  return (
    <div className="min-h-screen bg-zinc-50 py-10 px-4" data-testid={`sms-legal-${type}`}>
      <div className="mx-auto max-w-2xl">
        <Link
          to="/text-alerts"
          className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-800"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={15} /> Back to sign-up
        </Link>
        <div className="mt-4 rounded-2xl bg-white shadow-sm border border-zinc-200 px-6 py-8 sm:px-8">
          {sections.map((s, i) => (
            <section key={i} className={i === 0 ? "" : "mt-6"}>
              <h2
                className={
                  i === 0
                    ? "text-2xl font-bold text-zinc-900"
                    : "text-base font-semibold text-zinc-900"
                }
              >
                {s.h}
              </h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-2 text-sm leading-relaxed text-zinc-600">
                  {para}
                </p>
              ))}
            </section>
          ))}
          <p className="mt-8 text-xs text-zinc-400">
            Last updated {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}.
          </p>
        </div>
      </div>
    </div>
  );
}
